import { METHODS } from "../../config";
import { ENDPOINTS } from "../../config/endpoints";
import { fetchData } from "../../utils/fetchData";

export const getLibraryPageData = async () => {
  const data = await fetchData(ENDPOINTS.GET.LBRARY_PAGE, {
    method: METHODS.GET,
  });
  return data;
};
